import React from 'react';
import { Card } from 'Common/components/Atoms/Card';
import { Flex } from 'Common/components/Atoms/Flex';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { Link } from 'Common/components/Atoms/Link';
import { Text } from 'Common/components/Atoms/Text';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { useTheme } from '@mui/material/styles';
import { INELIGIBLE_CANDIDATE } from 'DisplayText/ReviewerOnboarding/IneligibleCandidate';
import { Email } from 'constants/email';
import { mail } from 'fluent-mailto';

function IneligibleCandidate() {
  const theme = useTheme();
  return (
    <React.Fragment>
      <Text variant="h2" component="h1" textAlign="center" mb="30px">
        {INELIGIBLE_CANDIDATE.TITLE}
      </Text>
      <Card p="30px 40px">
        <Text variant="body1" textAlign="center" mb="50px">
          {INELIGIBLE_CANDIDATE.SUBTITLE}
        </Text>
        <Flex
          background={theme.palette.highlight.dim}
          width="134px"
          height="134px"
          justifyContent="center"
          alignItems="center"
          margin="auto"
          borderRadius="50%"
        >
          <FontIcon
            icon={faTimes}
            size="6x"
            color={theme.palette.highlight.main}
          />
        </Flex>
        <Text mt="50px" textAlign="center" variant="body1">
          {INELIGIBLE_CANDIDATE.DESCRIPTION}
        </Text>
        <Text mt="30px" textAlign="center" variant="body1">
          Questions? Please contact{' '}
          <Link
            href={mail
              .to(Email.SUPPORT)
              .subject(INELIGIBLE_CANDIDATE.SUPPORT_SUBJECT)
              .build()}
          >
            {Email.SUPPORT}
          </Link>
        </Text>
      </Card>
    </React.Fragment>
  );
}

export default IneligibleCandidate;
